import { Page } from '../enums/page.enum';

import type { FolderSpaceInfo, MissionSpaceInfo } from './spaces.type';

export interface NavigationState {
  readonly folderSpaceInfo: FolderSpaceInfo | undefined;
  readonly missionSpaceInfo: MissionSpaceInfo | undefined;
  readonly page: Page;
}

export const initialState: NavigationState = {
  page: Page.Unregistered,
  folderSpaceInfo: undefined,
  missionSpaceInfo: undefined,
};
